// extracted by mini-css-extract-plugin
module.exports = {"modalBackdrop":"Modal_modalBackdrop__2cpc_","modalContent":"Modal_modalContent__1rYYD","iconBtn":"Modal_iconBtn__3snau","close":"Modal_close__3rW_Y"};